import PropTypes from "prop-types"
import { useCallback, useEffect, useRef, useState } from "react"

import api from "apis"

export default function fetchPrices(WrappedComponent) {
  const FetchPrices = ({
    product_option,
    sku_option,
    style_codes,
    ...props
  }) => {
    const [prices, setPrices] = useState({})
    const cancelled = useRef(false)

    const fetchPrices = useCallback(async () => {
      if (!cancelled.current) {
        try {
          let url = `/api/v10/products/prices?style_codes=${style_codes.join(
            ","
          )}`
          if (sku_option) {
            url += `&sku_option=${sku_option}`
          }
          if (product_option) {
            url += `&product_option=${product_option}`
          }
          const result = await api.get(url)
          setPrices(result.data)
        } catch (error) {
          console.log(error)
        }
      }
    }, [style_codes, sku_option, product_option])

    useEffect(() => {
      fetchPrices()
    }, [fetchPrices])

    useEffect(() => {
      return () => (cancelled.current = true)
    }, [])

    return <WrappedComponent prices={prices} {...props} />
  }

  FetchPrices.propTypes = {
    product_option: PropTypes.string,
    sku_option: PropTypes.string,
    style_codes: PropTypes.arrayOf(PropTypes.string).isRequired,
  }

  return FetchPrices
}
